export default "__VITE_ASSET__1d60b21f__"